import { mapActions } from 'vuex';
import Events from '_utils/events';
import ProductService from '_services/rest/modules/product';
import { _LOAD_MODEL_ } from './ProductModel';

export default {
  name: 'product-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      ProductService.deleteProduct(this.selectedObject)
        .then(() => {
          this.close();
          this.$router.push('/admin/produtos/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Produto deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    deleteEquipment() {
      this.setToggle({ type: 'progress', bool: true });
      ProductService.deleteEquipment(this.selectedObject)
        .then(response => {
          this.close();
          Events.$emit(_LOAD_MODEL_, response);
          this.activeAlert({ message: 'Equipamento deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
